module.exports = __webpack_public_path__ + "img/CH01-042-043.4c936c59.jpg";